import { render, staticRenderFns } from "./GalleryEdit.vue?vue&type=template&id=21c015b2&"
import script from "./GalleryEdit.vue?vue&type=script&lang=js&"
export * from "./GalleryEdit.vue?vue&type=script&lang=js&"
import style0 from "./GalleryEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports